module.exports = __webpack_public_path__ + "static/media/13.ae9243ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/13.png
// module id = 753
// module chunks = 0